const T_PREFIX = "clone-card";

export const infoParamsTrns = {
  rating: `${T_PREFIX}.info-params.rating`,
  profile: `${T_PREFIX}.info-params.profile`,
  address: `${T_PREFIX}.info-params.address`,
  phone: `${T_PREFIX}.info-params.phone`,
  website: `${T_PREFIX}.info-params.website`,
};

export const propertiesTrns = {
  investment: `${T_PREFIX}.properties.investment`,
  investmentValue: `${T_PREFIX}.properties.investment.value`,
};

export const actionButtonsTrns = {
  deleteButton: `${T_PREFIX}.action-buttons.delete-btn`,
  restoreButton: `${T_PREFIX}.action-buttons.restore-btn`,
  pauseButton: `${T_PREFIX}.action-buttons.pause-btn`,
  editButton: `${T_PREFIX}.action-buttons.edit-btn`,
};

export const actionButtonsModalTrns = {
  deleteModalDesc: `${T_PREFIX}.action-buttons.modal.delete`,
};
